import produce from 'immer'
import { baseReportUrl } from 'environments'
import { createActions, normalizeDateRange } from 'helpers/actions'
import entityNames from 'options/entityNames'

export default createActions(entityNames.overstockInventoryCycleCountDifferenceReport, {
  basePath: 'report/overstockInventoryReports',
  baseUrl: baseReportUrl,
  allowGetItems: (params) => params.locationGroupId,
  transformGetItemsParams: (params = {}) =>
    produce(params, (draft) => {
      normalizeDateRange(draft)
    }),
})
